import client from '../client';
import uuid from 'uuid';

export const FETCH_MOVEMENT_SPECIALIST_PROFILES = 'FETCH_MOVEMENT_SPECIALIST_PROFILES';
export const UPDATE_MOVEMENT_SPECIALIST_PROFILE = 'UPDATE_MOVEMENT_SPECIALIST_PROFILE';

export function fetchMovementSpecialistProfiles(query) {
  return {
    type: FETCH_MOVEMENT_SPECIALIST_PROFILES,
    promise: client.get('users/movement-specialist-profiles/all', query),
  };
}

export const updateMovementSpecialistProfile = (userId, values) => {
  const data = new FormData();
  if (values.profile_image_id) data.append('profile_image_id', values.profile_image_id);
  if (values.profile_image) data.append('profile_image', values.profile_image, uuid.v4());
  if (values.header_image_id) data.append('header_image_id', values.header_image_id);
  if (values.header_image) data.append('header_image', values.header_image, uuid.v4());

  data.append('availability', values.availability);
  data.append('biography', values.biography);
  data.append('hidden', values.hidden);
  data.append('longitude', values.longitude);
  data.append('latitude', values.latitude);
  data.append('location_short', values.location_short);
  data.append('location_long', values.location_long);
  data.append('name', values.name);

  return {
    promise: client.put(`users/${userId}/movement-specialist-profile`, data),
    type: UPDATE_MOVEMENT_SPECIALIST_PROFILE,
  };
};



// WEBPACK FOOTER //
// ./src/movement-specialists/actions.js